

/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useCallback, useEffect,useMemo, useRef, useState } from 'react'
import { APIEndpoint, DFPAPIEndpoint } from '../../../utils/axios';
import {editFields,editFields2,editFields3, editFields4, defaultEditFields, dimensionFields, unitStructureFields} from '../../../utils/itemSel'
import { DataGrid, EditModal,UploadModal } from '../../../common';
import DOWNLOAD_ICON from "../../../assets/icons/download-master.svg";
import { onDownloadXlsFile,formatCamelString } from '../../../utils/commonFunctions';
import {TrackingStat,HOST_SERVER,MIMETypes} from '../../../utils/configs';
import usePermissions from '../../../utils/userPermissions';
import { useTranslation } from 'react-i18next';
import editIcon2 from "../../../assets/edit2.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import searchIcon from '../../../assets/icons/search.svg';
import uploadItemIcon from '../../../assets/icons/upload-items.svg';
import LoadingGIF from '../../../assets/loadingIn.gif';

const DIMENSION_UNITS = [
  { key: 0, label: 'Select Dimension Unit', value: '' },
  { key: 1, label: 'Centimeter (cm)', value: 'cm' },
  { key: 2, label: 'Inch (in)', value: 'in' },
  { key: 3, label: 'Millimeter (mm)', value: 'mm' },
];

const VOLUME_UNITS = [
  { key: 0, label: 'Select Volume Unit', value: '' },
  { key: 1, label: 'Cubic Centimeter (cm3)', value: 'cm3' },
  { key: 2, label: 'Cubic Inch (in3)', value: 'in3' },
  { key: 3, label: 'Liter (L)', value: 'L' },
  { key: 4, label: 'Milliliter (mL)', value: 'mL' },
];

const SHAPE_OPTIONS = [
  { key: 0, label: 'Select Shape', value: '' },
  { key: 1, label: 'Box (Cuboid)', value: 'BOX' },
  { key: 2, label: 'Cylindrical', value: 'CYLINDRICAL' },
  { key: 3, label: 'Irregular', value: 'IRREGULAR' },
];

const DIMENSION_ATTRIBUTES = ['length', 'width', 'height', 'diameter', 'volume'];
const DEFAULT_PURCHASE_UNIT = 'CTN';
const DEFAULT_UPLIFT_UNIT = 'BOX';
const DEFAULT_SALES_UNIT = 'NOS';

const UNIT_STRUCTURE_ATTRIBUTES = [
  'purchaseUnit',
  'purchaseToUpliftQty',
  'upliftUnit',
  'upliftToSalesQty',
  'salesUnit',
  'salesUnitQty',
  'allowFractionalSalesUnit'
];

const parseNumeric = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const toPositiveNumber = (value, fallback = 1) => {
  const parsed = parseNumeric(value);
  if (parsed === null || parsed <= 0) return fallback;
  return parsed;
};

const normalizeSalesUnitQty = (value, allowFractionalSalesUnit) => {
  if (!allowFractionalSalesUnit) return 1;
  const parsed = parseNumeric(value);
  if (parsed === null || parsed <= 0) return 1;
  return Number(parsed.toFixed(4));
};

const getDimensionValue = (row, key) => {
  if (!row) return null;
  if (row[key] !== undefined && row[key] !== null) return row[key];
  if (row.dimensions && row.dimensions[key] !== undefined && row.dimensions[key] !== null) {
    return row.dimensions[key];
  }
  return null;
};

const getRowShape = (row) => row?.shape || row?.dimensions?.shape || '';

const formatDimensionsCell = (params) => {
  const row = params?.data;
  const shape = getRowShape(row);
  const length = getDimensionValue(row, 'length');
  const width = getDimensionValue(row, 'width');
  const height = getDimensionValue(row, 'height');
  const diameter = getDimensionValue(row, 'diameter');
  const volume = getDimensionValue(row, 'volume');
  const volumeUnit = row?.volumeUnit || row?.dimensions?.volumeUnit || '';

  let volumeStr = '';
  if (volume === null || volume === undefined || volume === '') {
    volumeStr = '';
  } else {
    volumeStr = `${volume}${volumeUnit ? ` ${volumeUnit}` : ''}`;
  }

  if (shape === 'CYLINDRICAL') {
    return `CYL: D ${diameter ?? '-'} x H ${height ?? '-'} = ${volumeStr || '-'}`;
  }

  if (shape === 'BOX' && (
        (length !== null && length !== undefined && length !== '') ||
        (width !== null && width !== undefined && width !== '') ||
        (height !== null && height !== undefined && height !== '')
      )
    ) {
    return `BOX: L ${length ?? '-'} x W ${width ?? '-'} x H ${height ?? '-'} = ${volumeStr || '-'}`;
  }

  if ( (length !== null && length !== undefined && length !== '') ||
      (width !== null && width !== undefined && width !== '') ||
      (height !== null && height !== undefined && height !== '')
  ) {
    return `L ${length ?? '-'} x W ${width ?? '-'} x H ${height ?? '-'} = ${volumeStr || '-'}`;
  }

  if (shape === 'IRREGULAR' && (volume !== null && volume !== undefined && volume !== '')) {
    return `VOL: ${volumeStr || '-'}`;
  }

  return '-';
};

const calculateVolumeByShape = (shape, values) => {
  const length = parseNumeric(values.length);
  const width = parseNumeric(values.width);
  const height = parseNumeric(values.height);
  const diameter = parseNumeric(values.diameter);

  if (shape === 'CYLINDRICAL') {
    if (diameter === null || height === null) return null;
    return Number((Math.PI * Math.pow(diameter / 2, 2) * height).toFixed(4));
  }

  if (shape === 'IRREGULAR') {
    return null;
  }

  if (length === null || width === null || height === null) return null;
  return Number((length * width * height).toFixed(4));
};

const Columns = [
  { field: 'itemCode',headerName: 'Item Code',tooltipField:'itemCode',flex:1, cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },suppressSizeToFit:true, resizable:true, minWidth: 140,width:190 },
  { field: 'itemName',headerName: 'Name', flex:1,suppressSizeToFit:true, resizable:true, minWidth: 200,width:250,
    tooltipField: 'itemName',  cellStyle: {
      whiteSpace: 'nowrap',
      overflow:'hidden',
      textOverflow:'ellipsis',
    },
  },
  { field: 'ssrCode', headerName: 'SSR Code',flex:1, suppressSizeToFit:true, resizable:true, minWidth: 135 },
  { field: 'itemType',headerName: 'Type', flex:1,suppressSizeToFit:true, resizable:true, minWidth: 135 },
  { field: 'itemClassifier',headerName: 'Classifier',valueGetter: (params) => {
    if (params.data&&params.data.itemClassifier) {
       return formatCamelString(params.data.itemClassifier);
    }
    return null;
  }, flex:1,suppressSizeToFit:true, resizable:true, minWidth: 135 },
  { field: 'category',headerName: 'Category',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },flex:1, suppressSizeToFit:true, resizable:true, minWidth: 155 },
  { field: 'subCategory',headerName: 'Sub Category',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },flex:1, minWidth: 175,suppressSizeToFit:true, resizable:true, },
  { field: 'hsn', headerName: 'HSN',flex:1,  suppressSizeToFit:true, resizable:true,minWidth: 125 },
  { field: 'dimensions', headerName: 'Dimensions', flex: 1, suppressSizeToFit: true, resizable: true, minWidth: 200, maxWidth: 220,
    valueGetter: formatDimensionsCell, tooltipValueGetter: formatDimensionsCell, 
   },
   { field: 'weight', headerName: 'Weight (g)', flex:1, suppressSizeToFit:true, resizable:true, minWidth: 90, tooltipValueGetter: (params) => {
     if (params.data && params.data.weight) {
       return `${params.data.weight} g`;
     }
     return null;
   } }
];

const EditFormFields = [
  {label: 'Item Type', attribute: 'itemType', type: 'select', disabled: false, options: [], required: true },
  {label: 'Item Code', attribute: 'itemCode', type: 'text', disabled: false, required: true },
  {label: 'Item Name', attribute: 'itemName', type: 'text', disabled: false, required: true},
  {label: 'SSR Code', attribute: 'ssrCode', type: 'text', disabled: false},
  {label: 'Category', attribute: 'category', type: 'select', disabled: false, options: [], required: true },
  {label: 'Sub category', attribute: 'subCategory', type: 'select', disabled: true, options: [], required: true },
  {label: 'Item Classifier', attribute: 'itemClassifier', type: 'select', disabled: false, options: [], required: true },
  {label: 'HSN Code', attribute: 'hsn', type: 'text', disabled: false},
  {label: 'Bar Code', attribute: 'barcode', type: 'text', disabled: false},
  {label: 'Section', attribute: 'section', type: 'select', disabled: false, options: [] },
  {label: 'Purchase Unit', attribute: 'purchaseUnit', type: 'select', disabled: false, options: [], required: false },
  {label: 'Qty in Purchase Unit', attribute: 'purchaseToUpliftQty', type: 'number', disabled: false, required: false},
  {label: 'Uplift Unit', attribute: 'upliftUnit', type: 'select', disabled: false, options: [], required: false },
  {label: 'Qty in Uplift Unit', attribute: 'upliftToSalesQty', type: 'number', disabled: false, required: false},
  {label: 'Sales Unit', attribute: 'salesUnit', type: 'select', disabled: false, options: [], required: true },
  {label: 'Sales Unit Qty', attribute: 'salesUnitQty', type: 'number', disabled: false, required: true},
  {label: 'Base Unit Qty', attribute: 'baseUnit', type: 'number', disabled: false},
  {label: 'Allow Fractional Sales Unit (e.g., 1.5)', attribute: 'allowFractionalSalesUnit', type: 'checkbox', disabled: false},
  {label: 'Unit', attribute: 'unit', type: 'hidden', disabled: true},
  {label: 'Color code', attribute: 'colorCode', type: 'text', disabled: false},
  {label: 'Replenishable', attribute: 'replenishable', type: 'number', disabled: false,note:"(Place an order even after stock is exhausted)" },
  {label: 'Description', attribute: 'description', type: 'textarea', disabled: false},
  ...dimensionFields.slice(0, 3),
  {label: 'Weight (in grams)', attribute: 'weight', type: 'number', disabled: false, required: false },
  ...dimensionFields.slice(3),
  {label: 'ItemId', attribute: 'itemId', type: 'hidden', disabled: true, required: true },
];

const AddFormFields = EditFormFields.filter((field) => field.attribute !== 'itemId');

export const ItemMasterPage = (props) => {
  const { t ,ready} = useTranslation();
  const [state, setState] = useState({imageRemoved:false});
  const tableRef = useRef();
  const [perPageLimit, ] = useState(50);
  const [searchKey, setSearchKey] = useState('');
  const [itemTypeList, setItemTypeList] = useState([]);
  const [selItemType, setItemType] = useState('');
  const [category, setCategory] = useState(null);
  const [subCat, setSubCat] = useState([]);
  const [subCatData, setSubCatData] = useState([]);
  const [catData, setCatData] = useState([]);
  const [units, setUnits] = useState([]);
  const [sections, setSections] = useState([]);
  const [image, setImage] = useState({});
  const [selectFields, setSelectFields] = useState({section:null});
  const [ uploadedFile, setUploadedFile ] = useState([])
  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [fileUpload, setFileUpload] = useState(null)
  const [showUpload, setShowUpload] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [editFormFields, setEditFormFields] = useState(EditFormFields);
  const[itemTypeValue,setItemTypeValue]=useState(null);
  const [itemClassifiers,setItemClassifiers]=useState([]);
  const [blobFile, setBlobFile] = useState(null)
  const[widthHeight,setWidthHeight]=useState();
  const[base64,setBase64]=useState("");
  const [isVolumeOverridden, setIsVolumeOverridden] = useState(false);
  const sType = localStorage.getItem('sType');
  const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);
  let invData={};
  const stateRef =useRef({});
  stateRef.current=state;

  const preCompile = useMemo(() => ({
    uploadTitle: t('pages.inventoryContent.itemMaster.uploadItems')
  }), [ready, t,state]);

    useEffect(() => {
      if(state.message){
        showToast();
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const { hasPermission: createitemMaster } = usePermissions('create', "orn:Account:ModifyItemMaster");
  const { hasPermission: edititemMaster } = usePermissions('edit', "orn:Account:ModifyItemMaster");
  const { hasPermission: viewitemMaster } = usePermissions('viewDetails',"orn:Account:ModifyItemMaster");
  const { hasPermission: downloaditemMaster } = usePermissions('download',"orn:Account:ModifyItemMaster");
  const { hasPermission: uploaditemMaster } = usePermissions('upload',"orn:Account:ModifyItemMaster");

  const fetchSubCategoryList = useCallback(
    async (categoryObj) => {
      setSubCatData([]);
      setSubCat([]);
      try {
      
        const resp = await DOMAIN.get('subcategories/' + categoryObj.key);
        if (resp.result.length > 0 && resp.success) {
          const options=[{key:0,label:'Select Sub Category',value1:"",value:""}];
          resp.result.forEach( (fieldValue, index) => {
              options.push({key: fieldValue.id, label: fieldValue.value,value1: fieldValue.value});
          });
          /**
           * Set to edit form sub category list
           */
  
          setSubCat( editFormFields.map( editRow => {
            if (editRow.attribute === 'subCategory' ) {
              editRow.initialValue=stateRef.current.selectedRows?.subCategory??"";
              editRow.value=stateRef.current.selectedRows?.subCategory??"";
              editRow.options=options;
              editRow.disabled=false;
            }
            return editRow;
          }))
  
          setSubCatData(options)
        }
        else {
  
        }
      } catch (error) {
        
      }
    },
    [state, editFormFields],
  )
  ;
  const showToast = () => {
    toast.dismiss();
      if (state.message) {
      toast.error(state.message?.text, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: false,
        autoClose: 3800,
        style: {
          backgroundColor: '#d9534f',
          color: '#fff',
          borderRadius: '8px',
          fontSize: '1rem',
          width:'30rem'
        }
      });
    }
  };
  const fetchItemTypes = useCallback(
    async () => {
      try {
          const resp = await DOMAIN.get('itemTypes');
      if (resp.result.length > 0 && !itemTypeList.length) {
        const options = [{key: 0, label:'Select Item Type', value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: fieldValue, value: fieldValue});
          return fieldValue;
        });

        setItemTypeList( options );

        /**
         * Set to edit form itemType list
         */

      }
      else {
      }
      } catch (error) {

      }

    },
    [],
  )

  const fetchItemClassifiers = useCallback(
    async () => {
      if(itemClassifiers.length)return;
      try {
          const resp = await DOMAIN.get('itemClassifiers');
      if (resp.result.length > 0 && !itemClassifiers.length) {
        const options = [{key: 0, label:'Select Item Classifier', value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: fieldValue.displayName, value: fieldValue.name});
          return fieldValue;
        });

        setItemClassifiers( options );

        /**
         * Set to edit form itemType list
         */

      }
      else {
      }
      } catch (error) {

      }

    },
    [],
  )
  
  const fetchUnits = useCallback(
    async () => {
      try {
         const resp = await DOMAIN.get('units');
      if (resp.result.length > 0 && units.length === 0) {
        const options = [{key: 0, label: 'Select Unit', value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: fieldValue, value: fieldValue});
          return fieldValue;
        });
        setUnits( options );

        /**
         * Set to edit form itemType list
         */

      }
      else {
      }
      } catch (error) {

      }

    },
    [units],
  )
  ;

  const fetchSection = useCallback(
    async () => {
      try {
        const resp = await DOMAIN.get('sections');
      if (resp.result.length>0 && !sections.length) {
        const options = [{key: 0, label: 'Select Section', value: ''}];
        resp.result.filter( (fieldValue, index) => {
          if (fieldValue!==""){
            if(fieldValue===null){
              options.push({key: index+1, label: "null", value: ""});
            }else{
              options.push({key: index+1, label: fieldValue, value: fieldValue});
            }
          }
          return fieldValue;
        });
        setSections( options );
        /**
         * Set to edit form section list
         */

      }
      else {
      }
      } catch (error) {

      }

    },
    [sections],
  )
  ;
  const fetchCategoryList = useCallback(
    async () => {
      try {
        const resp = await DOMAIN.get('categories');
      if (resp.result.length > 0 && !catData.length) {
        const options = [{key: 0, label: 'Select Category', value: ''}];
        resp.result.filter( (fieldValue) => {
          options.push({key: fieldValue.id, label: fieldValue.value, value: fieldValue.value});
          setCatData(options)
          return fieldValue;
        });

        /**
         * Set to edit form category list
         */

      } else {
      }
      } catch (error) {

      }


    },
    [catData],
  )
  const refreshTable = useCallback(
    () => {
      tableRef.current.refreshTableHandler(selItemType);
    },
    [selItemType],
  )
  const setImageObj=useCallback(
    ()=>{
      let locS=''
      if(blobFile?.length){
        const timestamp = new Date().getTime();
        locS= blobFile.replace("http://localhost:3000", HOST_SERVER)+`?t=${timestamp}`;
        setImage({
        imgName: fileUpload?.name,
        imgType: fileUpload?.type,
        imgSize: fileUpload?.size,
        _data: base64,
        width: widthHeight?.width,
        height: widthHeight?.height,
        localSrc: locS
    })
      }
    },
    [base64, blobFile, fileUpload, widthHeight],
  )
  const setEditFormCheckFields = useCallback(() => {
    const isEdit = stateRef.current?.selected?.action === 'editItem';
    const isAdd = stateRef.current?.selected?.action === 'addNewItem';

    const getFieldsForType = () => {
      const baseFields = isEdit ? [...EditFormFields] : [...AddFormFields];
      switch (itemTypeValue) {
        case "Product":
           return [...baseFields, ...editFields];
        case "Combo":
         {
           // Insert 'Tracking Strategy' after a specific field, e.g., after 'itemClassifier'
           const insertAfterAttr = 'itemClassifier'; // Change as appropriate
           const insertIndex = baseFields.findIndex(f => f.attribute === insertAfterAttr);
           const before = baseFields.slice(0, insertIndex + 1);
           const after = baseFields.slice(insertIndex + 1);
           return [
             ...before,
             { label: 'Tracking Strategy', attribute: 'trackingStrategy', type: 'select', disabled: false, options: [...TrackingStat], required: true },
             ...after,
             ...editFields
           ];
         }
        case "Serving":
        case "MRO":
          return isEdit ? [...EditFormFields, ...editFields2] : [...defaultEditFields, ...dimensionFields, ...unitStructureFields];
        case "Service":
          return isEdit ? [...EditFormFields, ...editFields4] : [...defaultEditFields, ...editFields4];

        case "SeatUpgrade":
          return isEdit ? [...EditFormFields, ...editFields3] : [...defaultEditFields];
        default:
          return [...defaultEditFields];
      }
    };

    const applyDimensionFieldState = (item, shapeValue, useShapeBasedValue) => {
      const shape = shapeValue || '';
      const useShapeBased = !!useShapeBasedValue;
      const disableShape = false; // !useShapeBased;

      if (item.attribute === 'shape') {
        return { ...item, disabled: disableShape };
      }

      if (item.attribute === 'diameter') {
        return { ...item, disabled: (!useShapeBased || shape !== 'CYLINDRICAL') };
      }

      if (item.attribute === 'length' || item.attribute === 'width') {
        if (shape === 'CYLINDRICAL') {
          return { ...item, disabled: true };
        }
        if (shape === 'IRREGULAR') {
          return { ...item, disabled: true };
        }
      }

      if (item.attribute === 'height') {
        if (shape === 'IRREGULAR') {
          return { ...item, disabled: true };
        }
      }

      if (item.attribute === 'volume') {
        return { ...item, disabled: shape !== 'IRREGULAR' };
      }

      return item;
    };

    const addCommonOptions = (item) => {
      if (item.attribute === 'itemType') {
        return { ...item, options: itemTypeList };
      }
      if (item.attribute === 'itemClassifier') {
        return { ...item, options: itemClassifiers };
      }
      if (item.attribute === 'section') {
        return { ...item, options: sections };
      }
      if (item.attribute === 'unit') {
        return { ...item, options: units };
      }
      if (item.attribute === 'purchaseUnit' || item.attribute === 'upliftUnit' || item.attribute === 'salesUnit' ) {
        return { ...item, options: units };
      }
      if (item.attribute === 'dimensionUnit') {
        return { ...item, options: DIMENSION_UNITS };
      }
      if (item.attribute === 'volumeUnit') {
        return { ...item, options: VOLUME_UNITS };
      }
      if (item.attribute === 'shape') {
        return { ...item, options: SHAPE_OPTIONS };
      }
      return item;
    };

    const  applyEditSettings = (item) => {
      let updated = addCommonOptions(item);
      const allowFractionalSalesUnit = stateRef.current.selected?.allowFractionalSalesUnit ?? stateRef.current.selectedRows?.allowFractionalSalesUnit ?? false;

      if (["itemType", "itemCode", "itemName"].includes(item.attribute)) {
        updated = { ...updated, disabled: true };
      }

      if (item.attribute === 'salesUnitQty') {
        updated = {
          ...updated,
          min: 0.0001,
          step: 0.0001,
          disabled: !allowFractionalSalesUnit
        };
      }

      if (item.attribute === 'category') {
        const value = stateRef.current.selectedRows?.category;
        const options = catData;
        const selCategoryObj = options.find(row => row.value === value);

        if (selCategoryObj) {
          setCategory(selCategoryObj);
        }
        updated = {
          ...updated,
          options,
          value
        };

      }

      const shapeValue = stateRef.current.selected?.shape || stateRef.current.selectedRows?.shape || '';
      const useShapeBasedValue = stateRef.current.selected?.useShapeBasedDimensions ?? stateRef.current.selectedRows?.useShapeBasedDimensions ?? false;
      return applyDimensionFieldState(updated, shapeValue, useShapeBasedValue);
    };

    const applyAddSettings = (item) => {
      let updated = addCommonOptions(item);

      if (["itemType", "itemCode", "itemName","itemClassifier"].includes(item.attribute)) {
        updated = { ...updated, disabled: false };
      }

      if (item.attribute === 'category') {
        updated = {
          ...updated,
          value: "",
          options: catData,
          initialValue: ""
        };
      }

      if (item.attribute === 'subCategory') {
        updated = {
          ...updated,
          options: [{ key: 0, label:'Select Sub Category', value1: '', value: '' }],
          disabled: true,
          initialValue: ""
        };
      }

      if (item.attribute === 'shape') {
        updated = {
          ...updated,
          initialValue: 'BOX'
        };
      }

      if (item.attribute === 'purchaseToUpliftQty' || item.attribute === 'upliftToSalesQty') {
        updated = {
          ...updated,
          initialValue: 1
        };
      }

      if (item.attribute === 'salesUnitQty') {
        updated = {
          ...updated,
          initialValue: 1,
          min: 0.0001,
          step: 0.0001,
          disabled: true
        };
      }

      if (item.attribute === 'baseUnit') {
        updated = {
          ...updated,
          initialValue: 1,
          disabled: true
        };
      }

      if (item.attribute === 'allowFractionalSalesUnit') {
        updated = {
          ...updated,
          initialValue: false
        };
      }

      if (item.attribute === 'purchaseUnit') {
        updated = {
          ...updated,
          initialValue: DEFAULT_PURCHASE_UNIT
        };
      }

      if (item.attribute === 'upliftUnit') {
        updated = {
          ...updated,
          initialValue: DEFAULT_UPLIFT_UNIT
        };
      }

      if (item.attribute === 'dimensionUnit') {
        updated = {
          ...updated,
          initialValue: ''
        };
      }

      if (item.attribute === 'volumeUnit') {
        updated = {
          ...updated,
          initialValue: ''
        };
      }

      if (item.attribute === 'unit') {
        updated = {
          ...updated,
          initialValue: DEFAULT_SALES_UNIT
        };
      }

      if (DIMENSION_ATTRIBUTES.includes(item.attribute)) {
        updated = {
          ...updated,
          initialValue: item.attribute === 'volume' ? 0 : ''
        };
      }

      return applyDimensionFieldState(updated, 'BOX', false);
    };

    if ((isEdit && stateRef.current.selectedRows) || isAdd) {
      const updatedFields = getFieldsForType().map(item =>
        isEdit ? applyEditSettings(item) : applyAddSettings(item)
      );
      setEditFormFields(updatedFields);

      if (isEdit) {
        const updatedSubCat = updatedFields.map(item => {
          if (item.attribute === "subCategory") {
            return {
              ...item,
              initialValue: stateRef.current.selectedRows.subCategory,
              value: stateRef.current.selectedRows.subCategory,
              disabled: false
            };
          }
          return item;
        });
        setSubCat(updatedSubCat);
      }
    }
  }, [itemTypeValue, itemTypeList,itemClassifiers, sections, units, catData]);



  React.useEffect( () => {
    refreshTable();
  }, [refreshTable, selItemType, tableRef]);

  React.useEffect( () => {
    if(!itemTypeList.length){
    fetchItemTypes();
    }
    if(!itemClassifiers.length){
      fetchItemClassifiers()
    }
  }, [ready]);

  React.useEffect( () => {
    setImageObj();
  }, [base64, blobFile, setImageObj, widthHeight]);

  React.useEffect( () => {
    if(state?.selected?.action!==""){
      stateRef.current=state;
      fetchCategoryList();
      fetchSection();
      fetchUnits();
      setEditFormCheckFields();
    }
  }, [state,itemTypeValue]);


  useEffect( () => {
    if (category) {
      fetchSubCategoryList(category);
    }
  }, [category, fetchSubCategoryList]);


  const onAction = async (e, action, selectedRowData) => {
    const {itemId,itemType,subCategory}=selectedRowData;
    setItemTypeValue(itemType);

    const resp = await DOMAIN.get(`inventory/items/${itemId}`);
    if (resp.success) {
       invData=resp.result;
      const unitStructure = resp.result.unitStructure || {};
      const purchaseToUpliftQty = toPositiveNumber(unitStructure.purchaseToUpliftQty ?? resp.result.purchaseToUpliftQty, 1);
      const upliftToSalesQty = toPositiveNumber(unitStructure.upliftToSalesQty ?? resp.result.upliftToSalesQty, 1);
      const salesUnit = unitStructure.salesUnit ?? resp.result.salesUnit ?? resp.result.unit ?? '';
      const purchaseUnit = unitStructure.purchaseUnit ?? resp.result.purchaseUnit ?? DEFAULT_PURCHASE_UNIT;
      const upliftUnit = unitStructure.upliftUnit ?? resp.result.upliftUnit ?? DEFAULT_UPLIFT_UNIT;
      const allowFractionalSalesUnit = Boolean(unitStructure.allowFractionalSalesUnit ?? resp.result.allowFractionalSalesUnit ?? false);
      const salesUnitQty = normalizeSalesUnitQty(
        unitStructure.salesUnitQty ?? resp.result.salesUnitQty,
        allowFractionalSalesUnit
      );
      const baseUnitQty = parseNumeric(unitStructure.baseUnitQty ?? resp.result.baseUnit);
      const resolvedBaseUnitQty = baseUnitQty ?? Number((purchaseToUpliftQty * upliftToSalesQty * salesUnitQty).toFixed(4));


      invData.category=resp.result.category.id??resp.result.category.value;
      invData.subCategory=resp.result.subCategory.id??resp.result.subCategory.value;
      invData.purchaseUnit = purchaseUnit;
      invData.purchaseToUpliftQty = purchaseToUpliftQty;
      invData.upliftUnit = upliftUnit;
      invData.upliftToSalesQty = upliftToSalesQty;
      invData.salesUnit = salesUnit;
      invData.salesUnitQty = salesUnitQty;
      invData.allowFractionalSalesUnit = allowFractionalSalesUnit;
      invData.unit = salesUnit;
      invData.baseUnit = resolvedBaseUnitQty;
      invData.useShapeBasedDimensions = Boolean(
        resp.result.useShapeBasedDimensions ?? resp.result.dimensions?.useShapeBasedDimensions ?? false
      );
      invData.shape = resp.result.shape ?? resp.result.dimensions?.shape ?? '';
      invData.dimensionUnit = resp.result.dimensionUnit ?? resp.result.dimensions?.dimensionUnit ?? '';
      invData.volumeUnit = resp.result.volumeUnit ?? resp.result.dimensions?.volumeUnit ?? '';
      invData.length = getDimensionValue(resp.result, 'length') ?? '';
      invData.width = getDimensionValue(resp.result, 'width') ?? '';
      invData.height = getDimensionValue(resp.result, 'height') ?? '';
      invData.diameter = getDimensionValue(resp.result, 'diameter') ?? '';
      invData.volume = getDimensionValue(resp.result, 'volume') ?? 0;
      if(invData){
        setState( (_prev) => {
          return { ..._prev,selectedRows:selectedRowData, selected: {...invData,  action: 'editItem' }}
        });
      }
    }


    else {
    }

  };
  const onFieldChangeHandler = (e, formUpdates = {}) => {
    const {name,value}=e.target;
    let changedFormValues = formUpdates;

    if(name==="itemType"){
      setItemTypeValue(value);
    }
    setModalFormStatusObj({ text: "" });
    if(name==='section'){
      setSelectFields({...selectFields,section:value})
    }

    if (UNIT_STRUCTURE_ATTRIBUTES.includes(name)) {
      const selectedState = stateRef.current?.selected || {};
      const purchaseToUpliftQty = toPositiveNumber(changedFormValues.purchaseToUpliftQty ?? selectedState.purchaseToUpliftQty, 1);
      const upliftToSalesQty = toPositiveNumber(changedFormValues.upliftToSalesQty ?? selectedState.upliftToSalesQty, 1);
      const salesUnit = changedFormValues.salesUnit ?? selectedState.salesUnit ?? '';
      const purchaseUnit = changedFormValues.purchaseUnit ?? selectedState.purchaseUnit ?? DEFAULT_PURCHASE_UNIT;
      const upliftUnit = changedFormValues.upliftUnit ?? selectedState.upliftUnit ?? DEFAULT_UPLIFT_UNIT;
      const allowFractionalSalesUnit = getItemChecked(changedFormValues, 'allowFractionalSalesUnit', selectedState.allowFractionalSalesUnit ?? false);
      const salesUnitQty = normalizeSalesUnitQty(
        changedFormValues.salesUnitQty ?? selectedState.salesUnitQty,
        allowFractionalSalesUnit
      );
      const baseUnitQty = Number((purchaseToUpliftQty * upliftToSalesQty * salesUnitQty).toFixed(4));

      changedFormValues = {
        ...changedFormValues,
        purchaseUnit,
        upliftUnit,
        salesUnit,
        purchaseToUpliftQty,
        upliftToSalesQty,
        salesUnitQty,
        allowFractionalSalesUnit,
        unit: salesUnit,
        baseUnit: baseUnitQty
      };

      setEditFormFields((prev) => prev.map((field) => {
        if (field.attribute === 'salesUnitQty') {
          return {
            ...field,
            disabled: !allowFractionalSalesUnit,
            value: salesUnitQty,
            initialValue: salesUnitQty
          };
        }
        if (field.attribute === 'baseUnit') {
          return {
            ...field,
            value: baseUnitQty,
            initialValue: baseUnitQty
          };
        }
        return field;
      }));

      return changedFormValues;
    }

    if (name === 'volume') {
      setIsVolumeOverridden(true);
    }

    if (name === 'shape' || name === 'useShapeBasedDimensions') {
      setIsVolumeOverridden(false);
    }

    if (name === 'shape' || name === 'useShapeBasedDimensions' || DIMENSION_ATTRIBUTES.includes(name)) {
      const selectedState = stateRef.current?.selected || {};
      const mergedValues = {
        useShapeBasedDimensions: changedFormValues.useShapeBasedDimensions ?? selectedState.useShapeBasedDimensions ?? false,
        shape: changedFormValues.shape ?? selectedState.shape ?? '',
        length: changedFormValues.length ?? selectedState.length,
        width: changedFormValues.width ?? selectedState.width,
        height: changedFormValues.height ?? selectedState.height,
        diameter: changedFormValues.diameter ?? selectedState.diameter,
        volume: changedFormValues.volume ?? selectedState.volume,
      };

      if (name === 'shape' && mergedValues.shape) {
        mergedValues.useShapeBasedDimensions = true;
        changedFormValues.useShapeBasedDimensions = true;
      }

      if (
        !mergedValues.shape &&
        (name === 'length' || name === 'width' || name === 'height' )
      ) {
        mergedValues.useShapeBasedDimensions = true;
        changedFormValues.useShapeBasedDimensions = true;
        mergedValues.shape = 'BOX';
        changedFormValues.shape = 'BOX';
      }

      const normalizedShape = mergedValues.useShapeBasedDimensions ? (mergedValues.shape || '') : '';
      if (!mergedValues.useShapeBasedDimensions) {
        mergedValues.shape = '';
        changedFormValues.shape = '';
      }

      const shouldAutoCalculate = name !== 'volume' && normalizedShape !== 'IRREGULAR' && !isVolumeOverridden;
      if (shouldAutoCalculate) {
        const autoVolume = calculateVolumeByShape(normalizedShape, mergedValues);
        if (autoVolume !== null) {
          changedFormValues = {
            ...changedFormValues,
            volume: autoVolume,
          };
        }
      }

      setEditFormFields((prev) => {
        return prev.map((field) => {
          if (field.attribute === 'shape') {
            return {
              ...field,
              disabled: !mergedValues.useShapeBasedDimensions,
              value: mergedValues.shape || 'BOX',
            };
          }

          if (field.attribute === 'diameter') {
            return {
              ...field,
              disabled: (!mergedValues.useShapeBasedDimensions || normalizedShape !== 'CYLINDRICAL')
            };
          }

          if (field.attribute === 'length' || field.attribute === 'width') {
            return {
              ...field,
              disabled: (normalizedShape === 'CYLINDRICAL' || normalizedShape === 'IRREGULAR')
            };
          }

          if (field.attribute === 'height') {
            return {
              ...field,
              disabled: normalizedShape === 'IRREGULAR'
            };
          }

          if (field.attribute === 'volume') {
            return {
              ...field,
              disabled: normalizedShape !== 'IRREGULAR'
            };
          }

          return field;
        });
      });

      return changedFormValues;
    }

    if (name === 'category') {
      const selCategory = value;
      /**
       * Set to edit form
       */
       editFormFields.map( editRow => {
        if (editRow.attribute === name) {
          editRow.value = selCategory;
          const selCategoryObj = editRow.options.find(row => row.value === selCategory);
          if (selCategoryObj) {
            //
            setCategory(selCategoryObj);
          }
        }
        return editRow;
      });
    }
    if (name === 'subCategory') {
      const selSubCategory = value;
      /**
       * Set to edit form
       */

       setSubCat(editFormFields.map( editRow => {
        if (editRow.attribute === "subCategory") {
          editRow.value = selSubCategory;
        }
        return editRow;
      }))
    }

    return changedFormValues;
  };
  const onClose = () => {
    setState((_prev) => {
      return { ..._prev, selected: false,imageRemoved:false }
    });
    editFormFields.forEach((items)=>{
    if(items.value||items.initialValue){
        delete items["value"];
        delete items["initialValue"];
      }
    })
    setModalFormStatusObj({text:''});
    setItemTypeValue(null);
    setSubCat([]);
    invData={};
    setImage({});
    setSubCatData([]);
    setCategory(null);
    setIsVolumeOverridden(false);
    resetImageSelection(false);
  }

  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
    searchParam: ''
  };

  const fetchItemMaster = async (page=1, perPage=50) => {
    if(!viewitemMaster){
      return{items:[],count:0}
    }
    filterData.page = page;
    filterData.limit = perPage;
    filterData.searchParam = searchKey;
    if (selItemType) {
      const isItemTypeExists = filterData.filters.find(row => row.itemType ? true : false);
      if (!isItemTypeExists) {
        filterData.filters.push({ itemType: selItemType });
      } else {
        filterData.filters.map( row => {
          row.itemType = selItemType;
          return row;
        });
      }
    }
    const res = await DOMAIN.post('master/process', JSON.stringify(filterData));
    return res;
  }

const onDownloadItemMaster=async()=>{
  if(isDownloading) return;
  let header={
    'Accept':'text/csv'
  }
    try {
      setIsDownloading(true)
    const res= await DOMAIN.post(`downloads/itemMaster`,{},header);
    if(res.status==='scheduled'){
      setTimeout(() => {
        const dowId = DOMAIN.get(`downloads/status/${res.id}`);
        dowId.then((val) => {
          if (val.status === "completed") {
              DOMAIN.get(`downloads/analytics/${val.fileName}${val.fileExtension}`)
                  .then((ItemMasterDwnld) => {
                      const url = window.URL.createObjectURL(new Blob([ItemMasterDwnld]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', val.fileName + '.csv');
                      document.body.appendChild(link);
                      link.click();
                      setIsDownloading(false);
                  })
                  .catch((error) => {

                      setIsDownloading(false);
                  });
          }
      });
        }, 4000);
    }
    }
     catch (error) {
      setState((_) => {
        return { ..._,message:{text:error?.data?.message},};
      })
      setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          message: null,
        }));
      }, 5000);
       setIsDownloading(false)
     }
  }
 const getCatSubCatObj=(obj=null,stateVal=null)=>{
  let catObj = {},
  subCatObj = {};

  if (obj === null && stateVal) {
    catObj = catData.find(c => (typeof stateVal.category==='number'?c.key ===stateVal.category:c.value === stateVal.category) );
    subCatObj = subCatData.find(c => (typeof stateVal.subCategory==='number'?c.key ===stateVal.subCategory:c.value === stateVal.subCategory));
  }

  else if (obj && obj.category) {
    catObj = catData.find(c => c.value === obj.category);
  }

  else if (obj && !obj.category && stateVal) {
    catObj = catData.find(c => (typeof stateVal.category==='number'?c.key ===stateVal.category:c.value === stateVal.category));
  }

  if (obj && obj.subCategory) {
    subCatObj = subCatData.find(c => c.value === obj.subCategory);
  }

  else if (obj && !obj.subCategory && stateVal) {
    subCatObj = subCatData.find(c => (typeof stateVal.subCategory==='number'?c.key ===stateVal.subCategory:c.value === stateVal.subCategory));
  }

  return [catObj, subCatObj];
 }

 const imageDimension=(imgData)=>{
  let i = new Image();
  i.onload = function(){
  setWidthHeight({width:i.width,height:i.height})
  };
  i.src = imgData;

}
const encodeImageFileAsURL = (element) => {

  if (element && (element instanceof File || element instanceof Blob)) {
    setBlobFile(URL.createObjectURL(element));
    setFileUpload(element);

    const reader = new FileReader();
    reader.onloadend = () => {
      imageDimension(reader.result);
      setBase64(reader.result);
    };
    reader.readAsDataURL(element);
  } else {

  }
};



const resetImageSelection=(closeReset=false)=>{
  if(closeReset){
    setState((_)=>({..._,selected:{..._.selected,image:null},imageRemoved:true}));
  }
  setImage({});
  setBlobFile(null);
  setFileUpload(null);
  setModalFormStatusObj({text:""})
 }

const getItemChecked=(updated,option,stateSel=false)=>{
if(updated && (updated[option]===true || updated[option]===false)){
 return updated[option];
 }
 else{
 return stateSel
}
}

const getResolvedUnitStructure = (updated = {}, selected = {}) => {
  const salesUnit = updated?.salesUnit ?? selected?.unitStructure?.salesUnit ?? selected?.unit ?? DEFAULT_SALES_UNIT;
  const purchaseUnit = updated?.purchaseUnit ?? selected?.unitStructure?.purchaseUnit ?? DEFAULT_PURCHASE_UNIT;
  const upliftUnit = updated?.upliftUnit ?? selected?.unitStructure?.upliftUnit ?? DEFAULT_UPLIFT_UNIT;
  const purchaseToUpliftQty = toPositiveNumber(updated?.purchaseToUpliftQty ?? selected?.unitStructure?.purchaseToUpliftQty, 1);
  const upliftToSalesQty = toPositiveNumber(updated?.upliftToSalesQty ?? selected?.unitStructure?.upliftToSalesQty, 1);
  const allowFractionalSalesUnit = getItemChecked(updated, 'allowFractionalSalesUnit', selected?.unitStructure?.allowFractionalSalesUnit ?? false);
  const salesUnitQty = normalizeSalesUnitQty(updated?.salesUnitQty ?? selected?.unitStructure?.salesUnitQty, allowFractionalSalesUnit);
  const baseUnitQty = Number((purchaseToUpliftQty * upliftToSalesQty * salesUnitQty).toFixed(4));

  return {
    purchaseUnit,
    upliftUnit,
    salesUnit,
    purchaseToUpliftQty,
    upliftToSalesQty,
    salesUnitQty,
    allowFractionalSalesUnit,
    baseUnitQty,
  };
};

const validateUnitStructure = (updated = {}, selected = {}) => {
  const structure = getResolvedUnitStructure(updated, selected);
  // if (!structure.purchaseUnit || !structure.upliftUnit || !structure.salesUnit) {
  if (!structure.salesUnit || !structure.salesUnitQty) {
    return 'Please select Sales unit and enter Sales unit quantity.';
  }
  if (structure.purchaseToUpliftQty <= 0 || structure.upliftToSalesQty <= 0) {
    return 'Conversion quantities must be greater than 0.';
  }
  return '';
};

const handleReset = () => {

  let timerId = setTimeout(() => {
    clearTimeout(timerId);
    setState((_) => {
      return { ..._, resetDataSource: !_.resetDataSource };
    })
    onClose();
  }, 1200)
}
const getImageStat = (mod, data) => {

  const imageSrc = Boolean(Object.keys(image).length) ? image : (mod?.image ?? data?.image);

  if (Boolean(Object.keys(image).length)) {
    return image;
  }
  return imageSrc ? { localSrc: imageSrc } : null;
};


const createItemMaster = (updated, selected, actionType) => {
  const [cat, subCat] = getCatSubCatObj(updated, selected);
  if(cat===undefined || subCat===undefined){
    setModalFormStatusObj({ error: "Category or Sub category Id is unknown." });
    return;
  } 

  const unitStructurePayload = getResolvedUnitStructure(updated, selected);

  const baseItemMaster = {
    itemId: updated?.itemId ?? selected?.itemId,
    itemName: updated?.itemName ?? selected?.itemName,
    itemCode: updated?.itemCode ?? selected?.itemCode,
    itemType: updated?.itemType ?? selected?.itemType,
    itemClassifier:updated?.itemClassifier ?? selected?.itemClassifier,
    trackingStrategy:updated?.trackingStrategy ?? selected?.trackingStrategy,
    ssrCode: updated?.ssrCode ?? selected?.ssrCode,
    hsn: updated?.hsn ?? selected?.hsn,
    barcode: updated?.barcode ?? selected?.barcode,
    category: {id:cat.key,value:cat.value},
    subCategory: {id:subCat.key,value:subCat.value},
    description: updated?.description ?? selected?.description,
    unit: unitStructurePayload.salesUnit,
    baseUnit: unitStructurePayload.baseUnitQty,
    section: updated?.section ?? selectFields.section ?? selected?.section,
    colorCode: updated?.colorCode ?? selected?.colorCode,
    replenishable: updated?.replenishable ?? selected?.replenishable,
    image:getImageStat(updated,selected),
    domestic: getItemChecked(updated, 'domestic', selected?.domestic),
    international: getItemChecked(updated, 'international', selected?.international),
    bob: getItemChecked(updated, 'bob', selected?.bob),
    corporate: getItemChecked(updated, 'corporate', selected?.corporate),
    webMeal: getItemChecked(updated, 'webMeal', selected?.webMeal),
    perishable: getItemChecked(updated, 'perishable', selected?.perishable),
    saleable: getItemChecked(updated, 'saleable', selected?.saleable),
    beverage: getItemChecked(updated, 'beverage', selected?.beverage),
    merchandise: getItemChecked(updated, 'merchandise', selected?.merchandise),
    stationary: getItemChecked(updated, 'stationary', selected?.stationary),
    groupMeal: getItemChecked(updated, 'groupMeal', selected?.groupMeal),
    crewMeal: getItemChecked(updated, 'crewMeal', selected?.crewMeal),
    liquor: getItemChecked(updated, 'liquor', selected?.liquor),
    dutyFree: getItemChecked(updated, 'dutyFree', selected?.dutyFree),
    additionalSmuLoadable: getItemChecked(updated, 'additionalSmuLoadable', selected?.additionalSmuLoadable),
    ...(!state.imageRemoved?{}:{shouldDeleteImage:state.imageRemoved}),
    smuLoadable:getItemChecked(updated, 'smuLoadable', selected?.smuLoadable),
    weight: updated?.weight !== undefined && updated?.weight !== '' && !isNaN(parseFloat(updated?.weight))
        ? Number(updated?.weight)
        : selected?.weight
  };

  baseItemMaster.dimensions = {
    useShapeBasedDimensions: getItemChecked(updated, 'useShapeBasedDimensions', selected?.useShapeBasedDimensions ?? false),
    shape: updated?.shape ? updated?.shape : selected?.shape ?? '',
    dimensionUnit: updated?.dimensionUnit ?? selected?.dimensionUnit ?? '',
    volumeUnit: updated?.volumeUnit ?? selected?.volumeUnit ?? '',
    length: parseNumeric(updated?.length ?? selected?.length ?? null),
    width: parseNumeric(updated?.width ?? selected?.width ?? null),
    height: parseNumeric(updated?.height ?? selected?.height ?? null),
    diameter: parseNumeric(updated?.diameter ?? selected?.diameter ?? null),
    volume: parseNumeric(updated?.volume ?? selected?.volume ?? null),
  };

  baseItemMaster.unitStructure = {
    purchaseUnit: unitStructurePayload.purchaseUnit,
    upliftUnit: unitStructurePayload.upliftUnit,
    salesUnit: unitStructurePayload.salesUnit,
    purchaseToUpliftQty: unitStructurePayload.purchaseToUpliftQty,
    upliftToSalesQty: unitStructurePayload.upliftToSalesQty,
    salesUnitQty: unitStructurePayload.salesUnitQty,
    baseUnitQty: unitStructurePayload.baseUnitQty,
    allowFractionalSalesUnit: unitStructurePayload.allowFractionalSalesUnit,
  };


  if (actionType === 'addNewItem') {
    baseItemMaster.itemName = updated?.itemName ?? '';
    baseItemMaster.itemCode = updated?.itemCode ?? '';
    baseItemMaster.description = updated?.description ?? '';
    baseItemMaster.unit = unitStructurePayload.salesUnit ?? '';
    baseItemMaster.baseUnit = unitStructurePayload.baseUnitQty ?? 1;
    baseItemMaster.image = Boolean(Object.keys(image).length) ? image : null;
  }

  return baseItemMaster;
};

const onEditSubmit = async (e, updated) => {
  const { selected } = state;
  const unitValidationMsg = validateUnitStructure(updated || {}, selected || {});
if((!selected?.itemClassifier && !updated?.itemClassifier)||(selected?.itemClassifier && updated?.itemClassifier==='')){
     setModalFormStatusObj({ error: "Please fill all mandatory fields*" });
}
else if(((updated?.itemType ?? selected?.itemType) ==='Combo') && ((!selected?.trackingStrategy && !updated?.trackingStrategy)||(selected?.trackingStrategy && updated?.trackingStrategy===''))){
     setModalFormStatusObj({ error: "Please fill all mandatory fields*" });
}
else if (unitValidationMsg) {
  setModalFormStatusObj({ error: unitValidationMsg });
}
else{
  const actionType = selected?.action;
  if (Boolean(updated) && actionType === 'editItem') {
    const bodyItemMaster = createItemMaster(updated, selected, 'editItem');
    if(!bodyItemMaster) return;
    try {
      const res = await DOMAIN.put(`inventory/items/${selected.itemId}`, bodyItemMaster);
      if (res.success) {
        setModalFormStatusObj({ text: res.msg });
        handleReset();
      }
    } catch (error) {

      const errObj = JSON.parse(error.message);
      setModalFormStatusObj({ error: errObj.data.msg });
    }
  }

  else if (updated === null && actionType === 'editItem') {
    const bodyItemMaster = createItemMaster(updated, selected, 'editItem');
    if(!bodyItemMaster) return;
    delete bodyItemMaster['action'];

    try {
      const res = await DOMAIN.put(`inventory/items/${bodyItemMaster.itemId}`, bodyItemMaster);
      if (res.success) {
        setModalFormStatusObj({ text: res.msg });
        handleReset();
      }
    } catch (error) {
      const errObj = JSON.parse(error?.message??error);
      if(!errObj.status){
        setModalFormStatusObj({ error:'Something went wrong. Please try again after some time.'});
      }else{
        setModalFormStatusObj({ error: errObj.data.message||errObj.data?.msg ||'Something went wrong. Please try again after some time.' });
      }

    }
  }

  else if (Boolean(updated) && actionType === 'addNewItem') {
    const bodyItemMaster = createItemMaster(updated, selected, 'addNewItem');
    if(!bodyItemMaster) return;
    try {
      const res = await DOMAIN.post(`inventory/items`, bodyItemMaster);
      if (res.success) {
        setModalFormStatusObj({ text: res.msg });
        handleReset();
      } else {
        setModalFormStatusObj({ text: res.message });
        handleReset();
      }
    } catch (error) {
      const errObj = JSON.parse(error.message);
      setModalFormStatusObj({ error: errObj.data.message||errObj.data?.msg });
    }
  }

  else if (actionType === 'addNewItem') {
    setModalFormStatusObj({ error: "Please fill all mandatory fields*" });
  }
}
};


  const onAddItemHandler = () => {

    setState( (_prev) => {
      return { ..._prev, selected: { action: 'addNewItem' } };
    });

    /**
     * Set to edit form
     */

  }
  // const onPerLimitChange = (e) => {
  //   setPerPageLimit(Number(e.target.value));
  // };

  const onSearch = (e) => {
      setSearchKey(e.target.value);
  };

  const onItemTypeChange = (e) => {
      setItemType(e.target.value);
  }
  const onUploadTaxMaster=()=>{
    setShowUpload(true)

  }
  const onUploadClose = () => {
    setUploadedFile([]);
    setShowUpload(false);
    setUploadFileStatusBlock('');
  }
  const onDownloadSampleFile = () => {
    onDownloadXlsFile('samples/downloads/Item_Master_Upload_Sample','Item_Master_Upload_Sample')
  }
  const onUploadFileChangeHandler = async (e) => {
    const file=e.target.files[0];
    setUploadedFile(e.target.files[0]);
    setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');

    const formData = new FormData();
    formData.append('scheduleLater', false);
    formData.append('listName', undefined);
    formData.append('targetSectorType', undefined);
    formData.append('stores', []);
    formData.append('warehouses', []);
    formData.append('file', file);

    try {
      await DOMAIN.post('inventory/upload', formData);
      setUploadedFile([]);
      setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
      setState( (_prev) => {
        return { ..._prev,resetDataSource:!_prev.resetDataSource}
      });

    }
    catch(error) {
      e.target.value = null;
      setUploadedFile([]);
      let { status, data } = JSON.parse( error.message );
      let msgHeading = data?.Error || data?.message || error.message;
      msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;
      let msgContent = "";
      if (status === 400) {
            data.errors.forEach( _ => {
            const lineNum = _.lineNumber;
            const errorMsgArr = [];
            _.errors.forEach(erObj => {
              errorMsgArr.push( erObj.field + ' | ' + erObj.message + ' \n<br>' );
            });

            msgContent += '<br>Line ' + lineNum + ': \n<br>' + errorMsgArr.join(' ');
        });
      } else if(status===0 && !data){

        msgContent += `Error occurred while uploading items sheet!<br>Please try again.`;
    }
      else {
        msgContent += `Error occurred while uploading items sheet!<br>Please fix the errors and re-upload.`;
      }


      setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                              );
    }
};

  return (
      <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        <>
  <div className="flexRow gap10 width100 margTop8 margBot10 justifyContentSpaceBetween">
  <div className="flexRow justifyContentFlexStart alignItemsBaseline">
    <button  className="saleType-div m-2 margLeft7">
      <select
        className="select-item darkBlue-bg"
        onChange={onItemTypeChange}
        value={selItemType !== null ? selItemType : ''}
        id="saleTypeId"
      >
        {itemTypeList.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </button>
  </div>

  <div className="flexRow justifyContentCenter alignItemsCenter width100 content-tabs">
    <div className="margLeft margBot10 margTop8 underline">
      <span><img className="icon-size" alt={t('filters.searchText')} src={searchIcon} /></span>
      <span>
        <input
          className="search"
          onChange={onSearch}
          type="search"
          placeholder={t('filters.searchText')}
          value={searchKey}
        />
      </span>
    </div>
  </div>
  <div className='flexRow margTop8 justifyContentFlexEnd'>
          <div className="margLeft flexRow justifyContentFlexEnd alignItemsBaseline">
          {uploaditemMaster?<button title={t('filters.uploadItems')} className='upload dropdownStyle1-TextMedium' onClick={() => onUploadTaxMaster(true)}> <span><img  className="icon-size-min" alt='uploadItem' src={uploadItemIcon} /></span></button>:<></>}&nbsp;
              {downloaditemMaster? <div className="flexRow justifyContentFlexStart margRight">

                      {isDownloading ? (
                               <button className="margRight" title={t('filters.downloadingMaster')}>
                                    <img
                                      src={LoadingGIF}
                                      className="margBottom0 icon-size-min"
                                      alt="Loading"
                                    />
                                  </button>
                              ) : (

                                  <button
                                    disabled={isDownloading}
                                    className="margRight"
                                    style={{ cursor: 'pointer' }}
                                    title={t('filters.downloadMaster')}
                                   onClick={onDownloadItemMaster}
                                  >
                                    <img src={DOWNLOAD_ICON} className="node-icon svg" alt="" />
                                  </button>
                                )
                              }

          </div>:<></>}

          </div>
        </div>

  {createitemMaster && (
    <div className="flexRow justifyContentFlexEnd">
      <button className="add-item-button m-2" onClick={onAddItemHandler}>
        {t('buttons.addItem')}
      </button>
    </div>
  )}

</div>


          <DataGrid
            ref={tableRef}
            className="full-flex"
            columns={[...Columns]}
            initialPageLimit={perPageLimit}
            showDefaultFilters={false}
            searchKey={searchKey}
            selItemType={selItemType}
            getRows={fetchItemMaster}
            rowSelection="multiple"
            actions={[{ title: '', detail: [{src: editIcon2,value:"EditItem",title:'Edit'}] }]}
            onAction={onAction}
            onAddItemHandler={onAddItemHandler}
            columnResize={true}
            resetDataSource={state.resetDataSource}
          />
        </>
      }
      {
        state && Boolean(state.selected) ?  (
          <EditModal
            key={state.selected.action}
            className='item-master-modal'
            title={(state.selected.action === 'editItem' && edititemMaster) ? 'Edit Item' : 'Add Item'}
            onClose={onClose}
            catData={catData}
            subCatData={subCatData}
            blobFile={blobFile}
            buttonLabel={'Save'}
            fileUpload={fileUpload}
            imageUrl={state?.selected?.image}
            resetImageSelection={resetImageSelection}
            encodeImageFileAsURL={encodeImageFileAsURL}
            modalFormStatusObj={modalFormStatusObj}
            setItemTypeValue={setItemTypeValue}
            onSubmit={onEditSubmit}
            onChange = {onFieldChangeHandler}
            fields={ subCat?.length>0?subCat.map( (elt) => {
              if (state.selected.action === 'editItem') {
                return {...elt, initialValue: state.selected[elt.attribute]?? ''}
              }
              else {
                return {...elt, initialValue: '' }
              }
            }):editFormFields.map( (elt) => {
                if (state.selected?.action === 'editItem') {
                  return {...elt, initialValue: state.selected[elt.attribute]?? ''}
                }
               
                else {
                  return {...elt, initialValue: '' }
                }
              })
            }
          />
        )
        : null
      }
      <ToastContainer/>
       {
        showUpload && uploaditemMaster &&
        <UploadModal
        modelTitle={preCompile.uploadTitle}
        onUploadClose={onUploadClose}
        onDownloadSampleFile={onDownloadSampleFile}
        uploadedFile = { uploadedFile }
        onUploadFileChangeHandler = { (e) => onUploadFileChangeHandler(e) }
        uploadFileStatusBlock = { uploadFileStatusBlock }
        allowedExtensions={ MIMETypes.excel }
        />
      }
      {
      !ready &&<div className='overlay_hide sub'></div>
      }
    </div>
  )
}
